module.exports = __webpack_public_path__ + "static/img/tai-sui-jin.f33aaa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/tai-sui-jin.jpg
// module id = pN8N
// module chunks = 1